import { render, staticRenderFns } from "./ModuleIndex2.vue?vue&type=template&id=398d9af8&scoped=true&"
import script from "./ModuleIndex2.vue?vue&type=script&lang=js&"
export * from "./ModuleIndex2.vue?vue&type=script&lang=js&"
import style0 from "./ModuleIndex2.vue?vue&type=style&index=0&id=398d9af8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d9af8",
  null
  
)

export default component.exports